import { useEffect, useState } from "react";
import ClientAdSettingsContent from "@components/Advertisement/components/ClientAdSettingsContent";
import { useUserInfo } from "@features/mySph/hooks/useUserInfo";

const ClientAdSettings = (): React.ReactElement => {
  const { isAuthenticated, userType } = useUserInfo();
  const [isClientDataInjected, setIsClientDataInjected] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;

    window.bt_page_data = {
      ...window.bt_page_data,
      userInfo: isAuthenticated ? { usertype: userType } : null,
    };

    setIsClientDataInjected(true);
  }, [isAuthenticated, userType]);

  return isClientDataInjected ? <ClientAdSettingsContent /> : <></>;
};

export default ClientAdSettings;
